import * as accountActions from '../actions/account';

const defaultState = {
    invite: null,
    signedUpUser: null,
    emailExists: null,
    isLoadingInvite: true,
    inviteInvalid: false,
};

export default function (state = defaultState, action) {
    switch (action.type) {
        case accountActions.INVITE_INVALID:
            return {
              ...state,
              inviteInvalid: true,
            };
      case accountActions.INVITE_REFRESHED:
            return {
                ...state,
                invite: action.invite,
                inviteInvalid: false,
            };
        case accountActions.SIGNED_UP_USER_REFRESHED:
            return {
                ...state,
                signedUpUser: action.signedUpUser,
            };
        case accountActions.EMAIL_EXISTS_REFRESHED:
            return {
                ...state,
                emailExists: action.emailExists,
            };
        case accountActions.TOGGLE_IS_LOADING_INVITE:
            return {
                ...state,
                isLoadingInvite: action.isLoadingInvite,
            };
        case accountActions.RESET:
            return defaultState;
        default:
            return state;
    }
}
